module.exports = __webpack_public_path__ + "img/class_logo.5f896903.png";